import React, { Component } from 'react';
import EnhancedTable from '../general/table.js';
import Config from '../config.js';
import Moment from 'react-moment';
import { Toolbar, Button, Dialog, DialogContent, DialogActions, TextField, Switch, FormControlLabel, Chip, Typography, Checkbox } from '@material-ui/core';
import { Link } from 'react-router-dom';
import RichTextEditor from 'react-rte';
import ExtendedSelect from '../general/select.js';
import DocumentLink from '../general/document_link.js';
import axios from 'axios';
import Auth from '../auth.js';
import DownloadButton from '../general/download_button.js';
import { getCompanyNames, parseSignalrMessage } from '../helpers.js';
import { PostStatusChip, postStatuses, ChangeStatusModal } from './thread.js';
import RepliedIcon from '@material-ui/icons/Lens';
import isEqual from 'lodash.isequal';
import { DeleteDialog, SaveDialog, SaveAsDialog } from '../files/import_export_profiles.js';
import { Alert } from "@material-ui/lab";

export const statusOptions = postStatuses.map(r => ({value: r, label: r}));

const signalrUpdate = async function(message, page, signalrOpts){
    message = parseSignalrMessage(message);
    if(!message.additionalData){
        return null;
    }
    let existing = page.find(r => r.Id === message.additionalData.ThreadId);
    if(message.action === 'newThreadMessage' && existing && message.additionalData.Category === "Status"){
        return {Id: existing.Id, Status: message.additionalData.Status, LastUpdated: message.additionalData.Date};
    }
    return null;
}

class MessageList extends Component {
    blankProfile = {Name: '', Subject: '', Body: RichTextEditor.createEmptyValue(), Shared: true};
    state = { showMessage: false, subject: '', showError: false, selected: [], showChangeStatus: false, updateStatus: '', externalEmails: '', 
        showTemplates: false, showSaveAs: false, showSave: false, confirmDelete: false, profile: {...this.blankProfile}, profiles: [], recipients: [] };
    constructor(props){
        super(props);
        this.profileSelect = React.createRef();
    }
    export = () => {
        let type ='xlsx';
        return {
            href: Config.api + `/odata/Company/Functions.ExportPosts?fileType=${type}` + (this.state.tableUrlBuilder.filter || '') + (this.state.tableUrlBuilder.orderBy || ''),
            fileName: "messages-" + Math.floor(Date.now() / 1000).toString() + '.' + type
    };
    }
    onError = (error) => {
        this.setState({showError: true, error: error});
    }
    createThread = async () => {
        try {
            this.setState({disableSend: true});
            await axios.post(Config.api + '/odata/Company/Functions.NewThread', {
                Subject: this.state.subject,
                Body: this.state.message.toString("html"),
                RequireAck: this.state.requireAck,
                Recipients: this.state.recipients,
                Status: this.state.status,
                ExternalEmails: this.state.externalEmails
            });
            this.setState({showMessage: false, refresh: !this.state.refresh, disableSend: false});
        }catch(e){

        }
    }
    newThread = () => {
        this.setState({showMessage: true, profile: this.blankProfile, message: RichTextEditor.createEmptyValue(), requireAck: false, recipients: [], subject: '', status: ''});
    }
    async componentDidMount(){
        var partners = (await axios.get(Config.api + '/api/v1/Partners')).data.Body.Partners.sort((a, b) => a.CompanyName.localeCompare(b.CompanyName));
        let profiles = await this.loadProfiles();
        this.setState({partners: partners.map(r => {return {label: r.CompanyName, value: r.Id}}), profiles});
    }
    loadProfiles = async () => {
        let saved = (await axios.get(Config.api + `/odata/Company/VwImportExportProfiles?$filter=Type eq 'Message'`)).data.value;
        let profiles = saved.map(r => ({...r, Profile: JSON.parse(r.Profile)})).map(r => ({Id: r.Id, Name: r.Name, Body: r.Profile.Body, Subject: r.Profile.Subject}));
        return profiles;
    }
    updateStatus = async () => {
        this.setState({disableUpdate: true});
        for(let i = 0; i < this.state.selected.length; i++){
            let thread = this.state.selected[i];
            try{
                await axios.post(Config.api + '/odata/Company/Functions.UpdatePostStatus', {ThreadId: thread.Id, Status: this.state.updateStatus});
            }catch{
    
            }
        }
        this.setState({disableUpdate: false, showChangeStatus: false, refresh: !this.state.refresh});
    }
    showChangeStatus = () => {
        this.setState({showChangeStatus: true});
    }
    onDelete = async () => {
        let profiles = await this.loadProfiles();
        this.setState({profile: {...this.blankProfile}, confirmDelete: false, profiles});
        this.profileSelect.current.setValue('');
    }
    onProfileNameChange = (val) => {
        this.setState((state) => {state.profile.Name = val; return state;});
    }
    getProfile = (name, profiles) => {
        let profile = (profiles || this.state.profiles).find(r => r.Name === name);
        if(profile){
            profile = {...profile};
            profile.Body = RichTextEditor.createValueFromString(profile.Body || '', 'html');
            this.setState({profile: profile});
        }
        return profile;
    }
    onProfileSelect = (name) => {
        if(!name){
            return;
        }
        let profile = this.getProfile(name);
        if(profile){
            this.setState({profile, subject: profile.Subject || '', message: profile.Body || RichTextEditor.createEmptyValue()});
        }
    }
    onSave = async () => {
        let profiles = await this.loadProfiles();
        this.setState({showSave: false, profiles, profile: this.getProfile(this.state.profile.Name, profiles)});
    }
    onSaveAs = async (newName) => {
        let profiles = await this.loadProfiles();
        await this.setState({showSaveAs: false, profiles, profile: this.getProfile(newName, profiles)});
        this.profileSelect.current.setValue(newName);
    }
    formatTemplate(values) {
        return {...values, Body: values.Body.toString('html')}
    }
    render(){
        let coid = parseInt(Auth.getAccountNumber());
        let config = {
            url: Config.api + "/odata/Company/VwCompanyPosts",
            columns: [
              { id: 'Id', hidden: true },
              { id: 'RequireAck', hidden: true, label: "Action Required", filterable: true, type: 'bool' },
              { id: 'Acknowledged', hidden: true, label: "Acknowledged", filterable: true, type: 'bool' },
              { id: 'Sender', hidden: true },
              { id: 'LastReplyByPartner', hidden: true },
              { id: 'DocumentType', hidden: true },
              { id: 'SenderName', filterable: true, label: 'From', width: '16em', getOptions: getCompanyNames },
              { id: 'Subject', filterable: true, label: 'Subject', template: (value, row) => <div>
                    <span style={{verticalAlign: 'middle', fontWeight: row.LastReplyByPartner ? 'bold' : ''}}>{value}</span>
                    {row.Sender !== coid && row.RequireAck && !row.Acknowledged ? <Chip label="Action Required" style={{marginLeft: '0.5rem', backgroundColor: "#EE3224", color: 'white', fontWeight: 'bold', minWidth: '8em' }}/> : ''}
                    {!(!row.LastReplyByPartner) && <RepliedIcon style={{color: "#ee3224", fontSize: "10px", marginLeft: "0.5em"}}/>}
                    </div> },
              { id: 'DocId', label: 'Document', template: (v, r) => <DocumentLink docType={r.DocumentType} id={v}>{v}</DocumentLink>, width: '12em' },
              { id: 'Status', filterable: true, sortable: true, label: 'Status', template: (value) => value ? <PostStatusChip status={value}/> : '', width: '15em' },
              { id: 'Date', type:'date', filterable: true, sortable: true, label: 'Date', template: (value) => (<Moment format='MM/DD/YYYY hh:mm A'>{value}</Moment>), width: '15em' },
              { id: 'LastUpdated', type:'date', filterable: true, sortable: true, label: 'Last Updated', template: (value) => value ? <Moment format='MM/DD/YYYY hh:mm A'>{value}</Moment> : '', width: '15em' },
              { id: 'HasExternalEmails', label: "CC Email", filterable: true, type: 'bool', width: '8em', template: (value, row) => (<Checkbox checked={value} style={{pointerEvents: 'none'}}/>)  },
              { id: 'Id', width: '10em', stopPropagation: 'true', template: (value, row) => {return (<Button variant='contained' component={Link} to={`/message-center/thread?id=${row.Id}`}>View</Button>);}}
          ],
          order: 'desc',
          orderBy: 'Id',
          keyField: 'Id',
          pageSize: 20,
          pageSizes: [10, 20, 50, 100],
          filterInUrl: true,
          selectable: true,
          title: 'Messages',
          refresh: this.state.refresh,
          signalr: this.props.signalr,
          onGetData: (builder) => this.setState({tableUrlBuilder: builder}),
          onSignalrUpdate: signalrUpdate,
          selectedActions: <div style={{display: 'flex'}}>
              <Button onClick={this.showChangeStatus}>Change Status</Button>
            </div>,
          actions: <div style={{marginTop: 'auto', marginBottom: 'auto', display: 'flex', gap: '1em'}}>
            <DownloadButton onError={this.onError} disabled={!this.state.tableUrlBuilder} size='small' variant='contained' onClick={this.export}>Export</DownloadButton>
            <Button size='small' onClick={() => this.setState({showTemplates: true, profile: this.blankProfile})} variant='contained'>Templates</Button>
            <Button size='small' onClick={this.newThread} color="primary" variant='contained' style={{minWidth: '10em'}}>New Message</Button>
            </div>,
          filter: {filters: [{field: "ThreadId", operator: 'eq', value: null}]},
          setSelected: (ids, models) => {
            if(!isEqual(models, this.state.selected)){
                this.setState({selected: models});
            }
          }
        }
        return (<div>
                    <EnhancedTable config={config}/>
                    <Dialog fullWidth={true} maxWidth='md' open={this.state.showMessage} onClose={() => this.setState({showMessage: false})}>
                        <Toolbar className='lbtoolbar'>New Message</Toolbar>
                        <DialogContent style={{flexDirection: 'column'}}>
                            <Typography style={{marginBottom: '1em'}}>To include recipients who are not registered with Logicbroker, you can input their email address(es) in the CC Email field. You may include multiple addresses separated by commas, spaces or semicolons.</Typography>
                            <div style={{flex: 1, display: 'flex', flexDirection: 'row'}}>
                                <TextField style={{flex: 1, marginRight: '1em'}} inputProps={{style: {padding: "8.5px 8.5px 8.5px 16px"}}} variant='outlined' placeholder='Subject' disabled={this.state.disableSend} value={this.state.subject} onChange={(e) => this.setState({subject: e.target.value})}/>
                                <ExtendedSelect variant='outlined' style={{flex: 1, display: 'flex'}} placeholder='Select template...' value={this.state.profile.Name} onChange={this.onProfileSelect} options={this.state.profiles.map(r => {return {label: r.Name, value: r.Name}})}/>
                            </div>
                            {this.state.partners ?
                                <div style={{marginTop: '1em', flexDirection: 'row', display: 'flex'}}>
                                <ExtendedSelect disabled={this.state.disableSend} allowSelectAll={true} style={{flex: 1, marginRight: '1em'}} variant='outlined' placeholder='Select recipients...' value={this.state.recipients} options={this.state.partners} onChange={(e) => this.setState({recipients: e})}/>
                                <TextField style={{flex: 1}} inputProps={{style: {padding: "8.5px 8.5px 8.5px 16px"}}} variant='outlined' placeholder='CC Email' disabled={this.state.disableSend} value={this.state.externalEmails} onChange={(e) => this.setState({externalEmails: e.target.value})}/>
                                </div>
                                : ''}
                            <div style={{marginTop: '1em', marginBottom: '1em', flexDirection: 'row', display: 'flex'}}>
                                <ExtendedSelect disabled={this.state.disableSend} style={{flex: 1, alignSelf: 'flex-end', marginRight: '1em'}} variant='outlined' placeholder='Status' value={this.state.status} options={statusOptions} onChange={(e) => this.setState({status: e})}/>
                                <div style={{flex: 1}}>
                                    <FormControlLabel control={<Switch checked={this.state.requireAck} disabled={this.state.disableSend} onChange={(e, value) => this.setState({requireAck: value})}/>} label='Require Acknowledgement'/>
                                </div>
                            </div>
                        <div style={{height: '200px', display: 'flex'}}>
                        <RichTextEditor className='textEditor' disabled={this.state.disableSend} value={this.state.message} onChange={(value) => this.setState({message: value})}/>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.createThread} disabled={!this.state.message || !this.state.message.getEditorState().getCurrentContent().hasText() || !this.state.subject || !this.state.recipients.length || this.state.disableSend} color="primary">
                          Send
                        </Button>
                    </DialogActions>
                    </Dialog>
                    <Dialog open={this.state.showError} onClose={() => {this.setState({showError: false})}}>
                        <Toolbar className='lbtoolbar'>Error</Toolbar>
                        <DialogContent><Typography>{this.state.error}</Typography></DialogContent>
                    </Dialog>
                    <ChangeStatusModal
                        open={this.state.showChangeStatus}
                        onClose={() => this.setState({showChangeStatus: false})}
                        value={this.state.updateStatus}
                        onChange={v => this.setState({updateStatus: v})}
                        submit={this.updateStatus}
                        disabled={this.state.disableUpdate}
                    />
                    <Dialog open={this.state.showTemplates} onClose={() => this.setState({showTemplates: false})} fullWidth maxWidth='md'>
                        <Toolbar className='lbtoolbar'>Message Templates</Toolbar>
                        <DialogContent style={{display: 'flex', flexDirection: 'column', gap: '1em'}}>
                            <Alert severity="info">
                                <Typography style={{textAlign: 'left'}}>To optimize the use of message templates, we recommend keeping the text generic or creating inputs such as [Supplier Name] to ensure the correct information is present.</Typography>
                            </Alert>
                            <div style={{display: 'flex'}}>
                                <ExtendedSelect innerRef={this.profileSelect} variant='outlined' style={{flex: '1 1 auto', display: 'flex'}} placeholder='Select template...' value={this.state.profile.Name} onChange={this.onProfileSelect} options={this.state.profiles.map(r => {return {label: r.Name, value: r.Name}})}/>
                                <DownloadButton disabled={!this.state.profile.Name} style={{marginRight: '1em', marginLeft: '1em'}} variant='contained' onClick={() => this.setState({showSave: true})}>Save</DownloadButton>
                                <Button style={{marginRight: '1em'}} variant='contained' disabled={!this.state.profile.Body || !this.state.profile.Body.getEditorState().getCurrentContent().hasText()} onClick={() => this.setState({showSaveAs: true})}>Save As</Button>
                                <Button disabled={!this.state.profile.Name} variant='contained' onClick={() => this.setState({confirmDelete: true})}>Delete</Button>
                            </div>
                            <div style={{flex: 1, display: 'flex', flexDirection: 'row'}}>
                                <TextField style={{flex: 1}} inputProps={{style: {padding: "8.5px 8.5px 8.5px 16px"}}} variant='outlined' placeholder='Subject' value={this.state.profile.Subject || ''} onChange={(e) => this.setState({profile: {...this.state.profile, Subject: e.target.value}})}/>
                            </div>
                            <RichTextEditor className='textEditor' value={this.state.profile.Body || ''} onChange={(value) => this.setState({profile: {...this.state.profile, Body: value}})}/>
                        </DialogContent>
                    </Dialog>
                    <SaveAsDialog open={this.state.showSaveAs} title='Save Template As' shared={true} format={this.formatTemplate} placeholder='New template name' onClose={() => this.setState({showSaveAs: false})} onSaveAs={this.onSaveAs} profileType='Message' values={this.state.profile}/>
                    <SaveDialog open={this.state.showSave} type={'template'} shared={true} format={this.formatTemplate} onClose={() => this.setState({showSave: false})} onSave={this.onSave} profileType='Message' values={this.state.profile}/>
                    <DeleteDialog open={this.state.confirmDelete} type={'template'} onClose={() => this.setState({confirmDelete: false})} onDelete={this.onDelete} profileType='Message' values={this.state.profile}/>
                </div>);
    }
}

export default MessageList;
